import { render, staticRenderFns } from "./Recuperar.vue?vue&type=template&id=206fe8fc&scoped=true"
import script from "./Recuperar.vue?vue&type=script&lang=js"
export * from "./Recuperar.vue?vue&type=script&lang=js"
import style0 from "./Recuperar.vue?vue&type=style&index=0&id=206fe8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fe8fc",
  null
  
)

export default component.exports